import * as Sentry from '@sentry/react';
import { base } from '../services/base';

// Routes where we DON'T want Session Replay (specific gantt and masterplan routes)
export const REPLAY_DISABLED_PATHS = [
  '/masterplan', // Any route starting with /masterplan
  '/gantt' // Any route starting with /gantt (includes /gantt/26928/ganttchart, /gantt/26928/calendars, etc.)
];

// Routes where we DON'T want Browser Tracing (performance monitoring)
export const TRACING_DISABLED_PATHS = [
  '/gantt' // Disable tracing for all gantt routes (heavy)
];

// Function to check if a route should have Session Replay disabled
// Works with dynamic routes: /gantt/26928/ganttchart, /gantt/54321/calendars, etc.
export const shouldDisableReplay = (path) =>
  REPLAY_DISABLED_PATHS.some(
    (disabledPath) =>
      path === disabledPath || path.startsWith(disabledPath + '/')
  );

// Function to check if a route should have Browser Tracing disabled
export const shouldDisableTracing = (path) =>
  TRACING_DISABLED_PATHS.some(
    (disabledPath) =>
      path === disabledPath || path.startsWith(disabledPath + '/')
  );

// Create Sentry configuration
export const createSentryConfig = (history) => ({
  dsn: 'https://6c707f47ee1d4264a9fbbde632e7fac7@o1357571.ingest.sentry.io/6735181',
  // Initialize with sample rates at 0 for manual control
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.reactRouterV5BrowserTracingIntegration({
      history
    }),
    Sentry.replayIntegration({
      block: ['.new-gantt-chart'],
      // Only record error replays if Session Replay is enabled for the route
      beforeErrorSampling: () => {
        const currentPath = window.location.pathname;
        const shouldRecord = !shouldDisableReplay(currentPath);
        return shouldRecord;
      }
    }),
    Sentry.replayCanvasIntegration()
  ],
  ignoreErrors: [/dhtmlxgantt/i],
  // Filter transactions by dynamic sample rate
  tracesSampler: (samplingContext) => {
    const currentPath =
      samplingContext.location?.pathname || window.location.pathname;
    const shouldFilter = shouldDisableTracing(currentPath);

    if (shouldFilter) {
      return 0; // 0% sample rate = no tracing
    }

    return 1.0; // 100% sample rate for other routes
  },
  environment: base.returnEnviroment,
  attachStacktrace: true,
  release: base.version ? base.version : 'not production',
  beforeSend(event) {
    const currentPath = window.location.pathname;
    const shouldFilter = shouldDisableReplay(currentPath);

    // Only filter Session Replay errors, not all errors
    if (shouldFilter && event.contexts?.replay) {
      return null;
    }

    // Allow all normal errors (non-replay) to pass through
    return event;
  },
  denyUrls: [/^\/$/]
});
